module.exports = __webpack_public_path__ + "img/9.19092694.jpg";